<template>
    <div class="gas-editor">
        <el-form ref="form" :model="gas" label-width="110px" :inline="true" v-if="gas">
            <el-form-item label="站点编号">
                <el-input v-model="gas.siteno" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="站点名称">
                <el-input v-model="gas.sitename" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="申报人">
                <el-input v-model="gas.applicant" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="是否可编辑" class="editeabled">
                <el-switch v-model="editeabled" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-form-item>

            <el-form-item label="申报日期">
                <el-input v-model="gas.time" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="提交时间">
                <el-input v-model="gas.create_time" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="00时段">
                <el-input v-model="gas.plan_00" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="01时段">
                <el-input v-model="gas.plan_01" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="02时段">
                <el-input v-model="gas.plan_02" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="03时段">
                <el-input v-model="gas.plan_03" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="04时段">
                <el-input v-model="gas.plan_04" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="05时段">
                <el-input v-model="gas.plan_05" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="06时段">
                <el-input v-model="gas.plan_06" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="07时段">
                <el-input v-model="gas.plan_07" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="08时段">
                <el-input v-model="gas.plan_08" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="09时段">
                <el-input v-model="gas.plan_09" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="10时段">
                <el-input v-model="gas.plan_10" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="11时段">
                <el-input v-model="gas.plan_11" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="12时段">
                <el-input v-model="gas.plan_12" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="13时段">
                <el-input v-model="gas.plan_13" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="14时段">
                <el-input v-model="gas.plan_14" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="16时段">
                <el-input v-model="gas.plan_16" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="17时段">
                <el-input v-model="gas.plan_17" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="18时段">
                <el-input v-model="gas.plan_18" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="19时段">
                <el-input v-model="gas.plan_19" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="20时段">
                <el-input v-model="gas.plan_20" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="21时段">
                <el-input v-model="gas.plan_21" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="22时段">
                <el-input v-model="gas.plan_22" :disabled="!editeabled"></el-input>
            </el-form-item>
            <el-form-item label="23时段">
                <el-input v-model="gas.plan_23" :disabled="!editeabled"></el-input>
            </el-form-item>
        </el-form>

        <div class="menu">
            <el-button type="primary" @click="okHandle">确定</el-button>
            <el-button @click="handleCanel">取消</el-button>
        </div>
    </div>
</template>

<script>
import {updateGas} from "@/api/gas.js";

export default {
    name:"gaseditor",
    props:['gas'],
    data(){
        return {
            editeabled:false,
        }
    },
    mounted(){
        if(this.gas.editeabled){
            this.editeabled=true;
        }
    },
    methods:{
        // 确定
        okHandle(){
            let gas=this.gas;
            if(this.editeabled){
                gas.editeabled=1;
            }else{
                gas.editeabled=0;
            }
            // 更新数据
            updateGas(gas).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"数据更新成功",
                        type:"success",
                        duration:3000,
                        onClose:()=>{
                            this.$emit("ok");
                        }
                    })

                }
            });
        },
        // 取消
        handleCanel(){
            this.$emit("ok");
        }
    }
}
</script>

<style lang="scss" scoped>
.gas-editor{

    .editeabled{
        ::v-deep .el-form-item__content{
            width:160px;
        }
    }

    ::v-deep .el-input{
        width:160px;
    }

    .menu{
        text-align: center;
    }
}
</style>